import { createFileRoute } from "@tanstack/react-router";
import { ProgrammaticAdvertisingServicePage } from "./services_.programmatic-advertising";

export const Route = createFileRoute("/services_/programmatic-advertising-services")({
  head: () => ({
    meta: [
      {
        title: "Programmatic Advertising Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Automated Data-Driven Programmatic Ad Buying.",
      },
    ],
  }),
  component: ProgrammaticAdvertisingServicePage,
});
